

export function triggerChartTooltip(index = 0) {

    const chart = window.activeChart

    const tooltip = chart.tooltip;
    if (tooltip.getActiveElements().length > 0) {
        tooltip.setActiveElements([], {x: 0, y: 0});
    } else {
        const chartArea = chart.chartArea;
        tooltip.setActiveElements([
                {
                    datasetIndex: 0,
                    index: index,
                }
            ],
            {
                x: (chartArea.left + chartArea.right) / 2,
                y: (chartArea.top + chartArea.bottom) / 2,
            });
    }

    chart.update();
}
